import "./TheArchives.module.css";
import Navigation from "@/reusable_sections/Header";
import VisualTaxonomy from "./sections/VisualTaxonomy";
import PrintInquiry from "./sections/PrintInquiry";
import FooterArchive from "@/reusable_sections/Footer";
export default function TheArchivesPage() {
  return <div>
      <Navigation />
      <VisualTaxonomy />
      <PrintInquiry />
      <FooterArchive />
    </div>;
}